import { localizedDistanceInWordsToNow } from '../utils/dateFormatters'

export default {
  methods: {
    timeFromNow: localizedDistanceInWordsToNow
  }
}
